/**
 * Created by Victor Rojo on 2/12/19.
 */
import { Injectable, Optional }     from '@angular/core';
import { HttpClient, HttpResponse, HttpParams } from '@angular/common/http';

import {PetrolDiscountTransaction} from "./PetrolDiscountTransaction";
import {Page} from "../../model/page";

@Injectable()
export class PetrolDiscountTransactionService{

  private basePath = "/ipetrol/api/v1/discount_transaction";
  constructor(
    private http: HttpClient
  ) { }

  private errorHandler(error: any): Promise<any> {
    console.log('An error occurred', error);
    return Promise.reject(error.message || error);
  }

  getPage(page=0, size=20, sort="", filter=""){
    let url = this.basePath;
    let params = new HttpParams();
    params = params.append('page', page.toString())
      .append('size', size.toString())
      .append('sort', sort)
      .append('filter', filter);
    return this.http
      .get(url, { params: params })
      .toPromise()
      .then( response => response as Page )
      .catch(error => this.errorHandler(error));
  }

}
